import { GetDocumentById, GetDocumentByIdToken } from "$src/application/projects/sub/documents/queries/GetDocumentById";
import { DocumentSummary } from "$src/domain/projects/documents/DocumentSummary";
import { useQuery } from "@sveltestack/svelte-query";
import { container } from "tsyringe";

interface FetchDocumentsParams {
    queryKey: ['document', number, number, string];
}

export async function fetchDocument( { queryKey } : FetchDocumentsParams): Promise<DocumentSummary> {
    const [_, groupStoreId, projectId, documentId] = queryKey;
    const query = container.resolve<GetDocumentById>(GetDocumentByIdToken);
    return query.execute(groupStoreId, projectId, documentId);
}

export function useDocument(groupStoreId: number, projectId: number, documentId: string) {
    return useQuery<DocumentSummary, Error, DocumentSummary, ['document', number, number, string]>(
        ['document', groupStoreId, projectId, documentId], 
        fetchDocument,
        {
            staleTime: 30000,
            cacheTime: 60000,
        }
    );
}